// extracted by mini-css-extract-plugin
export var emailBlockLink = "_fe-0";